import useReveal from "@/hooks/useReveal";
import { offerTiers } from "@/lib/offers";
import { offerBtn, SmartLink } from "@/components/CompanyUi";

export default function OfferStrip() {
    const { ref, visible } = useReveal();
    return (
        <section id="offers" data-testid="offers-section" className="bg-white px-5 py-14 sm:py-20">
            <div className="mx-auto max-w-5xl">
                <div ref={ref} className={`reveal mb-9 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between ${visible ? "is-visible" : ""}`}>
                    <div className="max-w-xl">
                        <span className="rounded-full bg-[var(--brand-soft)] px-3 py-1 text-xs font-semibold uppercase tracking-wide text-[var(--brand)]">
                            Pricing
                        </span>
                        <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight text-[#0a0a0b] sm:text-4xl">
                            What you can buy today.
                        </h2>
                        <p className="mt-3 text-[15px] leading-relaxed text-[#5b5b66]">
                            Live SKUs with locked prices. Custom work is a free diagnostic, then a fixed proposal.
                        </p>
                    </div>
                    <SmartLink href="/pricing" className="text-sm font-semibold text-[var(--brand)] hover:underline">
                        Full pricing →
                    </SmartLink>
                </div>
                <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
                    {offerTiers.map((tier, i) => (
                        <TierCard key={tier.name} tier={tier} i={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}

function TierCard({ tier, i }) {
    const { ref, visible } = useReveal({ threshold: 0.12 });
    return (
        <article
            ref={ref}
            style={{ transitionDelay: `${i * 70}ms` }}
            className={`reveal flex h-full flex-col rounded-3xl p-5 ring-1 ${
                tier.highlight
                    ? "bg-[var(--brand)] text-white ring-[var(--brand)] shadow-[0_18px_44px_rgba(43,80,255,0.28)]"
                    : "bg-white text-[#0a0a0b] ring-black/5"
            } ${visible ? "is-visible" : ""}`}
        >
            <p className={`text-xs font-semibold uppercase tracking-wide ${tier.highlight ? "text-white/70" : "text-[var(--brand)]"}`}>
                {tier.name}
            </p>
            <h3 className="mt-1 font-display text-lg font-bold">{tier.sku}</h3>
            <p className="mt-3 font-display text-3xl font-extrabold">{tier.price}</p>
            <p className={`text-xs ${tier.highlight ? "text-white/70" : "text-[#6b6b75]"}`}>{tier.cadence}</p>
            <ul className={`mt-4 flex-1 space-y-2 text-sm leading-relaxed ${tier.highlight ? "text-white/90" : "text-[#5b5b66]"}`}>
                {tier.points.map((p) => (
                    <li key={p}>{p}</li>
                ))}
            </ul>
            <SmartLink
                href={tier.href}
                className={`mt-5 ${tier.highlight ? "rounded-full bg-white px-5 py-2.5 text-center text-sm font-semibold text-[var(--brand)]" : offerBtn}`}
            >
                {tier.cta}
            </SmartLink>
        </article>
    );
}
